import React, { Component } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { LocalstorageKeys } from './../../types/enums'
import './ErrorsComponent.scss'

interface IErrorsComponentState {
  lastAuthError: string
}

const lastAuthErrorDefValue = 'No errors'

class ErrorsComponent extends Component<WithTranslation, IErrorsComponentState> {
  private textAreaRef: React.RefObject<HTMLTextAreaElement> = React.createRef()
  constructor(props: WithTranslation) {
    super(props)
    this.state = {
      lastAuthError: lastAuthErrorDefValue,
    }
  }

  componentDidMount() {
    this.textAreaRef = React.createRef<HTMLTextAreaElement>()
    this.updateData()
  }

  render() {
    const { lastAuthError } = this.state
    return (
      <div className="errors-component">
        <textarea readOnly={true} ref={this.textAreaRef} value={lastAuthError} />
        <button onClick={() => this.copyToClipboard()}>Copy</button>
        <button onClick={() => this.clear()}>Clear</button>
      </div>
    )
  }

  private updateData() {
    this.setState({
      lastAuthError: window.localStorage.getItem(LocalstorageKeys.lastOidcError) || lastAuthErrorDefValue,
    })
  }

  private copyToClipboard() {
    if (this.textAreaRef.current) {
      this.textAreaRef.current.select()
      document.execCommand('copy')
    }
  }

  private clear() {
    this.setState({
      lastAuthError: lastAuthErrorDefValue,
    })
    window.localStorage.removeItem(LocalstorageKeys.lastOidcError)
  }
}

export default withTranslation('common')(ErrorsComponent)
